<template>
  <div class="field">
    <label class="label">{{ label }}</label>
    <div class="field-body icons-selector">
      <div
        v-for="item in values"
        class="selector-item"
        :class="{ 'disabled-item': disabled, inactive: !item.selected }"
        :key="item.name"
        @click="toggle(item)"
      >
        <div>
          <img
            class="icon"
            v-if="item.icon"
            :src="item.icon"
            :alt="item.name"
          />
        </div>
        <span class="item-name">
          <input
            type="checkbox"
            :disabled="disabled"
            :checked="item.selected"
          />
          {{ $t(item.name) }}
        </span>
      </div>
    </div>
    <p class="help is-danger">{{ $t(errors && errors[0]) }}</p>
  </div>
</template>

<script>
// value = ["name1", "name2"]
export default {
  name: "icons-selector",
  props: ["value", "options", "label", "disabled", "errors"],
  computed: {
    values() {
      return this.options.map(element => ({
        ...element,
        selected: this.value.includes(element.name)
      }))
    }
  },
  methods: {
    toggle(item) {
      if (this.disabled) {
        return
      }
      if (!item.selected) {
        this.$emit("input", [...this.value, item.name])
      } else {
        this.$emit(
          "input",
          this.value.filter(name => name !== item.name)
        )
      }
    }
  }
}
</script>

<style lang="scss">
// TODO: optimize html & css
.icons-selector {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  .selector-item {
    cursor: pointer;
    user-select: none;
    padding: 0 12px 16px 0px;
    img {
      min-width: 72px;
      min-height: 72px;
    }
    .item-name {
      font-size: 0.75rem;
      display: block;
      float: left;
      text-align: center;
      width: 100%;
      input {
        margin-right: 4px;
      }
    }
  }
  .disabled-item {
    cursor: not-allowed;
  }
  div.inactive {
    img {
      filter: grayscale(100%);
      transform: scale(0.95);
    }
  }
}
</style>
